<template>
  <div class="detail_content">
    <div class="detail_label">
      {{titleLabel}}
    </div>
    <textarea rows='4' cols='40' class='detail_input_field' @input="inputUpdate"></textarea>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    inputUpdate (e) {
      this.$emit('inputUpdate', e)
    }
  }
}
</script>
<style scoped>
.detail_input_field {
  height: 110px;
  padding: 10px;
  width: calc(100% - 60px);
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/textAreaSection.vue